import MobileMenuIcon from '../../../../ui/svg/common/mobile-menu';
import React from 'react';
import { EVENT_LIST_MENU_MOBILE_OPEN } from '../../../menus/list-menu/services/list-menu-provider';

const Top = () => {
    const openMobileMenu = () => {
        document.dispatchEvent(new Event(EVENT_LIST_MENU_MOBILE_OPEN));
    }

    return (
        <>
            <div className="w-full lg:hidden">
                <div className="py-4">
                    <div className="w-fit" onClick={() => openMobileMenu()}>
                        <MobileMenuIcon width="44px"/>
                    </div>
                </div>
            </div>
            <div className="w-full pl-2">
                <h1 className="waves-h1">Search Support</h1>
            </div>
        </>
    )
};

export default Top;